var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-text__label",attrs:{"for":_vm.id}},[_vm._t("default",function(){return [_vm._v("氏")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }